<app-layout>
  <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="card shadow p-4" style="max-width: 400px; width: 100%">
      <h3 class="text-center mb-4">Redefinir Senha</h3>

      <form (ngSubmit)="onSubmit()" [formGroup]="resetPasswordForm">
        <div class="mb-3">
          <label for="newPassword" class="form-label">Nova Senha</label>
          <div class="input-group">
            <input
              [type]="hideNew ? 'password' : 'text'"
              id="newPassword"
              formControlName="newPassword"
              class="form-control"
              placeholder="Digite sua nova senha"
              required />
            <button class="btn btn-outline-secondary" type="button" (click)="hideNew = !hideNew">
              @if (hideNew) {
                <i class="pi pi-eye"></i>
              } @else {
                <i class="pi pi-eye-slash"></i>
              }
            </button>
          </div>
          @if (resetPasswordForm.get("newPassword")?.touched && resetPasswordForm.get("newPassword")?.invalid) {
            <div class="text-danger">Tamanho mínimo da senha é 6 digitos.</div>
          }
        </div>

        <div class="mb-3">
          <label for="confirmPassword" class="form-label">Confirmar Senha</label>
          <div class="input-group">
            <input
              [type]="hideConfirm ? 'password' : 'text'"
              id="confirmPassword"
              formControlName="confirmPassword"
              class="form-control"
              placeholder="Confirme sua nova senha"
              required />
            <button class="btn btn-outline-secondary" type="button" (click)="hideConfirm = !hideConfirm">
              @if (hideConfirm) {
                <i class="pi pi-eye"></i>
              } @else {
                <i class="pi pi-eye-slash"></i>
              }
            </button>
          </div>
        </div>
        @if (resetPasswordForm.get("confirmPassword")?.touched && resetPasswordForm.hasError("mismatch")) {
          <div class="text-danger">As senhas devem ser iguais.</div>
        }

        <div class="d-grid">
          <app-button type="submit" [disabled]="resetPasswordForm.invalid || loading"> Redefinir Senha </app-button>
        </div>
      </form>
    </div>
  </div>
</app-layout>
